// Central config + demo detection.
// When CAMP_HR_SUPABASE_URL is missing or still the .env.example placeholder,
// the app runs in DEMO mode: auth is bypassed (fake admin) and all data comes
// from src/lib/demo.js. Drop in real Supabase creds and demo mode turns off.

export const SUPABASE_URL = process.env.CAMP_HR_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = process.env.CAMP_HR_SUPABASE_ANON_KEY || '';

export const IS_DEMO =
  !SUPABASE_URL ||
  SUPABASE_URL.includes('YOUR-PROJECT') ||
  !SUPABASE_ANON_KEY ||
  SUPABASE_ANON_KEY === 'eyJ...';
